// extracted by mini-css-extract-plugin
export default {"root":"_1xHnP","large":"_1BZl4","hoverable":"_3O2Tr","medium":"_1CVmj","small":"_107Jm"};